export const SET_LOCATION_CONFIG = 'SET_LOCATION_CONFIG'
export const SET_LOCATION_DESIGN_CONFIG = 'SET_LOCATION_DESIGN_CONFIG'
export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS'
export const SET_GOALS = 'SET_GOALS'
export const SET_SELECTED_ORGANIZATION = 'SET_SELECTED_ORGANIZATION'
export const SET_SELECTED_GOAL = 'SET_SELECTED_GOAL'
export const SET_AMOUNT = 'SET_AMOUNT'
export const SET_RULES = 'SET_RULES'
export const SET_VOUCHERS = 'SET_VOUCHERS'
export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO'
